import { checkIsUploadableSound } from "utils/before-upload"
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons"
import { Input, Upload } from "antd"
import React, { FC } from "react"
import { useFileUpload } from "hooks/useFileUpload"

export const UploadSoundComponent: FC<{
  soundFile: string;
  style?: React.CSSProperties;
  setSoundFile: React.Dispatch<React.SetStateAction<string>> | ((soundFile: string) => void);
  placeholder?: string;
  title?: string;
  maxSize?: number; // MB
  required?: boolean;
  requiredError?: boolean;
  name?: string;
  disabled?: boolean;
}> = ({
  soundFile,
  setSoundFile,
  style,
  maxSize,
  placeholder,
  title,
  required,
  requiredError,
  name,
  disabled,
}) => {
  const { isLoading, uploadFile } = useFileUpload()

  const getSoundPreview = () => {
    if (soundFile && (soundFile.endsWith("mp3") || soundFile.endsWith("wav") || soundFile.endsWith("ogg") || soundFile.endsWith("aac"))) {
      return (
        <audio
          style={{ width: "300px", height: "40px" }}
          src={soundFile}
          controls
        />
      )
    }

    return null
  }

  return (
    <div style={style}>
      {title && (
        <div style={{ fontWeight: "500" }}>
          {title}
          {required && <span style={{ color: "red" }}> *</span>}
        </div>
      )}
      <Upload
        name={name}
        showUploadList={false}
        className={!soundFile ? "avatar-uploader" : "avatar-uploader"}
        listType={!soundFile ? "picture-card" : "picture-card"}
        multiple={true}
        action={async file => {
          const url = await uploadFile(file)
          setSoundFile(url)

          return url
        }}
        beforeUpload={file => checkIsUploadableSound(file, maxSize)}
        disabled={disabled}
      >
        {soundFile && getSoundPreview()}
        {!soundFile && isLoading && <LoadingOutlined />}
        {!soundFile && !isLoading && <PlusOutlined />}
        {!soundFile && <div className="ant-upload-text">{placeholder || "Upload"}</div>}
      </Upload>
      {requiredError && <div style={{ color: "red", marginBottom: 4 }}>Sound file is required</div>}
      <Input
        value={soundFile}
        onChange={e => setSoundFile(e.target.value)}
        placeholder="Select sound file or input link"
        status={requiredError ? "error" : undefined}
        disabled={disabled}
      />
    </div>
  )
}
